/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { medicalAidIdGet } from '../fn/medical-aid/medical-aid-id-get';
import { MedicalAidIdGet$Params } from '../fn/medical-aid/medical-aid-id-get';
import { medicalAidMedicalAidIdMedicalAidSchemeIdSearchMedicalAidOptionPost } from '../fn/medical-aid/medical-aid-medical-aid-id-medical-aid-scheme-id-search-medical-aid-option-post';
import { MedicalAidMedicalAidIdMedicalAidSchemeIdSearchMedicalAidOptionPost$Params } from '../fn/medical-aid/medical-aid-medical-aid-id-medical-aid-scheme-id-search-medical-aid-option-post';
import { medicalAidMedicalAidIdSearchMedicalAidSchemePost } from '../fn/medical-aid/medical-aid-medical-aid-id-search-medical-aid-scheme-post';
import { MedicalAidMedicalAidIdSearchMedicalAidSchemePost$Params } from '../fn/medical-aid/medical-aid-medical-aid-id-search-medical-aid-scheme-post';
import { medicalAidMedicalAidOptionGetMedicalAidIdMedicalAidSchemeIdMedicalAidOptionIdGet } from '../fn/medical-aid/medical-aid-medical-aid-option-get-medical-aid-id-medical-aid-scheme-id-medical-aid-option-id-get';
import { MedicalAidMedicalAidOptionGetMedicalAidIdMedicalAidSchemeIdMedicalAidOptionIdGet$Params } from '../fn/medical-aid/medical-aid-medical-aid-option-get-medical-aid-id-medical-aid-scheme-id-medical-aid-option-id-get';
import { medicalAidMedicalAidOptionSaveMedicalAidIdMedicalAidSchemeIdPost } from '../fn/medical-aid/medical-aid-medical-aid-option-save-medical-aid-id-medical-aid-scheme-id-post';
import { MedicalAidMedicalAidOptionSaveMedicalAidIdMedicalAidSchemeIdPost$Params } from '../fn/medical-aid/medical-aid-medical-aid-option-save-medical-aid-id-medical-aid-scheme-id-post';
import { medicalAidMedicalAidSchemeGetMedicalAidIdMedicalAidSchemeIdGet } from '../fn/medical-aid/medical-aid-medical-aid-scheme-get-medical-aid-id-medical-aid-scheme-id-get';
import { MedicalAidMedicalAidSchemeGetMedicalAidIdMedicalAidSchemeIdGet$Params } from '../fn/medical-aid/medical-aid-medical-aid-scheme-get-medical-aid-id-medical-aid-scheme-id-get';
import { medicalAidMedicalAidSchemeSaveMedicalAidIdPost } from '../fn/medical-aid/medical-aid-medical-aid-scheme-save-medical-aid-id-post';
import { MedicalAidMedicalAidSchemeSaveMedicalAidIdPost$Params } from '../fn/medical-aid/medical-aid-medical-aid-scheme-save-medical-aid-id-post';
import { MedicalAidModel } from '../models/medical-aid-model';
import { MedicalAidModelSearchResultModel } from '../models/medical-aid-model-search-result-model';
import { MedicalAidOptionModel } from '../models/medical-aid-option-model';
import { MedicalAidOptionModelSearchResultModel } from '../models/medical-aid-option-model-search-result-model';
import { medicalAidPost } from '../fn/medical-aid/medical-aid-post';
import { MedicalAidPost$Params } from '../fn/medical-aid/medical-aid-post';
import { MedicalAidSchemeModel } from '../models/medical-aid-scheme-model';
import { MedicalAidSchemeModelSearchResultModel } from '../models/medical-aid-scheme-model-search-result-model';
import { medicalAidSearchMedicalAidPost } from '../fn/medical-aid/medical-aid-search-medical-aid-post';
import { MedicalAidSearchMedicalAidPost$Params } from '../fn/medical-aid/medical-aid-search-medical-aid-post';

@Injectable({ providedIn: 'root' })
export class MDIMedicalAidService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `medicalAidSearchMedicalAidPost()` */
  static readonly MedicalAidSearchMedicalAidPostPath = '/MedicalAid/SearchMedicalAid';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `medicalAidSearchMedicalAidPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  medicalAidSearchMedicalAidPost$Response(params?: MedicalAidSearchMedicalAidPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<MedicalAidModelSearchResultModel>> {
    return medicalAidSearchMedicalAidPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `medicalAidSearchMedicalAidPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  medicalAidSearchMedicalAidPost(params?: MedicalAidSearchMedicalAidPost$Params, context?: HttpContext): Observable<MedicalAidModelSearchResultModel> {
    return this.medicalAidSearchMedicalAidPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<MedicalAidModelSearchResultModel>): MedicalAidModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `medicalAidIdGet()` */
  static readonly MedicalAidIdGetPath = '/MedicalAid/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `medicalAidIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  medicalAidIdGet$Response(params: MedicalAidIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<MedicalAidModel>> {
    return medicalAidIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `medicalAidIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  medicalAidIdGet(params: MedicalAidIdGet$Params, context?: HttpContext): Observable<MedicalAidModel> {
    return this.medicalAidIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<MedicalAidModel>): MedicalAidModel => r.body)
    );
  }

  /** Path part for operation `medicalAidPost()` */
  static readonly MedicalAidPostPath = '/MedicalAid';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `medicalAidPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  medicalAidPost$Response(params?: MedicalAidPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return medicalAidPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `medicalAidPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  medicalAidPost(params?: MedicalAidPost$Params, context?: HttpContext): Observable<string> {
    return this.medicalAidPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `medicalAidMedicalAidIdSearchMedicalAidSchemePost()` */
  static readonly MedicalAidMedicalAidIdSearchMedicalAidSchemePostPath = '/MedicalAid/{medicalAidId}/SearchMedicalAidScheme';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `medicalAidMedicalAidIdSearchMedicalAidSchemePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  medicalAidMedicalAidIdSearchMedicalAidSchemePost$Response(params: MedicalAidMedicalAidIdSearchMedicalAidSchemePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<MedicalAidSchemeModelSearchResultModel>> {
    return medicalAidMedicalAidIdSearchMedicalAidSchemePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `medicalAidMedicalAidIdSearchMedicalAidSchemePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  medicalAidMedicalAidIdSearchMedicalAidSchemePost(params: MedicalAidMedicalAidIdSearchMedicalAidSchemePost$Params, context?: HttpContext): Observable<MedicalAidSchemeModelSearchResultModel> {
    return this.medicalAidMedicalAidIdSearchMedicalAidSchemePost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<MedicalAidSchemeModelSearchResultModel>): MedicalAidSchemeModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `medicalAidMedicalAidSchemeGetMedicalAidIdMedicalAidSchemeIdGet()` */
  static readonly MedicalAidMedicalAidSchemeGetMedicalAidIdMedicalAidSchemeIdGetPath = '/MedicalAid/MedicalAidSchemeGet/{medicalAidId}/{medicalAidSchemeId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `medicalAidMedicalAidSchemeGetMedicalAidIdMedicalAidSchemeIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  medicalAidMedicalAidSchemeGetMedicalAidIdMedicalAidSchemeIdGet$Response(params: MedicalAidMedicalAidSchemeGetMedicalAidIdMedicalAidSchemeIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<MedicalAidSchemeModel>> {
    return medicalAidMedicalAidSchemeGetMedicalAidIdMedicalAidSchemeIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `medicalAidMedicalAidSchemeGetMedicalAidIdMedicalAidSchemeIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  medicalAidMedicalAidSchemeGetMedicalAidIdMedicalAidSchemeIdGet(params: MedicalAidMedicalAidSchemeGetMedicalAidIdMedicalAidSchemeIdGet$Params, context?: HttpContext): Observable<MedicalAidSchemeModel> {
    return this.medicalAidMedicalAidSchemeGetMedicalAidIdMedicalAidSchemeIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<MedicalAidSchemeModel>): MedicalAidSchemeModel => r.body)
    );
  }

  /** Path part for operation `medicalAidMedicalAidSchemeSaveMedicalAidIdPost()` */
  static readonly MedicalAidMedicalAidSchemeSaveMedicalAidIdPostPath = '/MedicalAid/MedicalAidSchemeSave/{medicalAidId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `medicalAidMedicalAidSchemeSaveMedicalAidIdPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  medicalAidMedicalAidSchemeSaveMedicalAidIdPost$Response(params: MedicalAidMedicalAidSchemeSaveMedicalAidIdPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return medicalAidMedicalAidSchemeSaveMedicalAidIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `medicalAidMedicalAidSchemeSaveMedicalAidIdPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  medicalAidMedicalAidSchemeSaveMedicalAidIdPost(params: MedicalAidMedicalAidSchemeSaveMedicalAidIdPost$Params, context?: HttpContext): Observable<string> {
    return this.medicalAidMedicalAidSchemeSaveMedicalAidIdPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

  /** Path part for operation `medicalAidMedicalAidIdMedicalAidSchemeIdSearchMedicalAidOptionPost()` */
  static readonly MedicalAidMedicalAidIdMedicalAidSchemeIdSearchMedicalAidOptionPostPath = '/MedicalAid/{medicalAidId}/{medicalAidSchemeId}/SearchMedicalAidOption';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `medicalAidMedicalAidIdMedicalAidSchemeIdSearchMedicalAidOptionPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  medicalAidMedicalAidIdMedicalAidSchemeIdSearchMedicalAidOptionPost$Response(params: MedicalAidMedicalAidIdMedicalAidSchemeIdSearchMedicalAidOptionPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<MedicalAidOptionModelSearchResultModel>> {
    return medicalAidMedicalAidIdMedicalAidSchemeIdSearchMedicalAidOptionPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `medicalAidMedicalAidIdMedicalAidSchemeIdSearchMedicalAidOptionPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  medicalAidMedicalAidIdMedicalAidSchemeIdSearchMedicalAidOptionPost(params: MedicalAidMedicalAidIdMedicalAidSchemeIdSearchMedicalAidOptionPost$Params, context?: HttpContext): Observable<MedicalAidOptionModelSearchResultModel> {
    return this.medicalAidMedicalAidIdMedicalAidSchemeIdSearchMedicalAidOptionPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<MedicalAidOptionModelSearchResultModel>): MedicalAidOptionModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `medicalAidMedicalAidOptionGetMedicalAidIdMedicalAidSchemeIdMedicalAidOptionIdGet()` */
  static readonly MedicalAidMedicalAidOptionGetMedicalAidIdMedicalAidSchemeIdMedicalAidOptionIdGetPath = '/MedicalAid/MedicalAidOptionGet/{medicalAidId}/{medicalAidSchemeId}/{medicalAidOptionId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `medicalAidMedicalAidOptionGetMedicalAidIdMedicalAidSchemeIdMedicalAidOptionIdGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  medicalAidMedicalAidOptionGetMedicalAidIdMedicalAidSchemeIdMedicalAidOptionIdGet$Response(params: MedicalAidMedicalAidOptionGetMedicalAidIdMedicalAidSchemeIdMedicalAidOptionIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<MedicalAidOptionModel>> {
    return medicalAidMedicalAidOptionGetMedicalAidIdMedicalAidSchemeIdMedicalAidOptionIdGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `medicalAidMedicalAidOptionGetMedicalAidIdMedicalAidSchemeIdMedicalAidOptionIdGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  medicalAidMedicalAidOptionGetMedicalAidIdMedicalAidSchemeIdMedicalAidOptionIdGet(params: MedicalAidMedicalAidOptionGetMedicalAidIdMedicalAidSchemeIdMedicalAidOptionIdGet$Params, context?: HttpContext): Observable<MedicalAidOptionModel> {
    return this.medicalAidMedicalAidOptionGetMedicalAidIdMedicalAidSchemeIdMedicalAidOptionIdGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<MedicalAidOptionModel>): MedicalAidOptionModel => r.body)
    );
  }

  /** Path part for operation `medicalAidMedicalAidOptionSaveMedicalAidIdMedicalAidSchemeIdPost()` */
  static readonly MedicalAidMedicalAidOptionSaveMedicalAidIdMedicalAidSchemeIdPostPath = '/MedicalAid/MedicalAidOptionSave/{medicalAidId}/{medicalAidSchemeId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `medicalAidMedicalAidOptionSaveMedicalAidIdMedicalAidSchemeIdPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  medicalAidMedicalAidOptionSaveMedicalAidIdMedicalAidSchemeIdPost$Response(params: MedicalAidMedicalAidOptionSaveMedicalAidIdMedicalAidSchemeIdPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return medicalAidMedicalAidOptionSaveMedicalAidIdMedicalAidSchemeIdPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `medicalAidMedicalAidOptionSaveMedicalAidIdMedicalAidSchemeIdPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  medicalAidMedicalAidOptionSaveMedicalAidIdMedicalAidSchemeIdPost(params: MedicalAidMedicalAidOptionSaveMedicalAidIdMedicalAidSchemeIdPost$Params, context?: HttpContext): Observable<string> {
    return this.medicalAidMedicalAidOptionSaveMedicalAidIdMedicalAidSchemeIdPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
